export default "<div id=\"{{ vm.id }}\" class=\"accordion-container\" ng-transclude></div> ";